/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';

const ScheduledDraftsPage = () => import('./ScheduledDraftsPage.vue');

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/conversations/:conversation_id/scheduled-drafts'
      ),
      name: 'scheduled_drafts',
      roles: ['administrator', 'agent'],
      component: ScheduledDraftsPage,
      props: route => ({
        conversationId: route.params.conversation_id,
        draftId: route.query.draft_id,
      }),
    },
  ],
};

